import { colors } from "@theme/colors"

const HelmIcon = ({
  color = colors.iconPrimary,
  height = 24,
  width = 24,
}: {
  color?: string
  height?: number
  width?: number
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8387 1.16129C10.8387 0.519927 11.3586 0 12 0C12.6414 0 13.1613 0.519927 13.1613 1.16129V2.39154C14.9641 2.60714 16.6146 3.31837 17.9727 4.38508L18.8431 3.51471C19.2966 3.0612 20.0319 3.0612 20.4854 3.51471C20.9389 3.96823 20.9389 4.70351 20.4854 5.15703L19.615 6.0274C20.6817 7.38547 21.3929 9.03596 21.6085 10.8387H22.8387C23.4801 10.8387 24 11.3586 24 12C24 12.6414 23.4801 13.1613 22.8387 13.1613H21.6085C21.3929 14.964 20.6817 16.6145 19.6151 17.9725L20.4856 18.843C20.9391 19.2965 20.9391 20.0318 20.4856 20.4853C20.0321 20.9388 19.2968 20.9388 18.8433 20.4853L17.9728 19.6149C16.6147 20.6816 14.9641 21.3929 13.1613 21.6085V22.8387C13.1613 23.4801 12.6414 24 12 24C11.3586 24 10.8387 23.4801 10.8387 22.8387V21.6085C9.03596 21.3929 7.38547 20.6817 6.0274 19.615L5.15709 20.4853C4.70358 20.9388 3.96829 20.9388 3.51478 20.4853C3.06127 20.0318 3.06127 19.2965 3.51478 18.843L4.38507 17.9727C3.31837 16.6146 2.60714 14.9641 2.39154 13.1613H1.16129C0.519927 13.1613 0 12.6414 0 12C0 11.3586 0.519927 10.8387 1.16129 10.8387H2.39154C2.60715 9.03586 3.31841 7.3853 4.38515 6.02719L3.51496 5.157C3.06144 4.70349 3.06144 3.9682 3.51496 3.51469C3.96847 3.06117 4.70376 3.06117 5.15727 3.51469L6.02749 4.38491C7.38555 3.3183 9.036 2.60713 10.8387 2.39154V1.16129ZM12 19.3548C9.9709 19.3548 8.13372 18.5331 6.80305 17.2044L6.79941 17.2007L6.79574 17.197C5.46689 15.8664 4.64516 14.0291 4.64516 12C4.64516 9.97516 5.46341 8.14143 6.78728 6.81143L6.79958 6.79931L6.81167 6.78705C8.14165 5.46331 9.97528 4.64516 12 4.64516C16.062 4.64516 19.3548 7.93804 19.3548 12C19.3548 16.062 16.062 19.3548 12 19.3548ZM14.7097 12C14.7097 13.4965 13.4965 14.7097 12 14.7097C10.5035 14.7097 9.29032 13.4965 9.29032 12C9.29032 10.5035 10.5035 9.29032 12 9.29032C13.4965 9.29032 14.7097 10.5035 14.7097 12ZM17.0323 12C17.0323 14.7792 14.7792 17.0323 12 17.0323C9.22076 17.0323 6.96774 14.7792 6.96774 12C6.96774 9.22076 9.22076 6.96774 12 6.96774C14.7792 6.96774 17.0323 9.22076 17.0323 12Z"
        fill={color}
      />
    </svg>
  )
}

export default HelmIcon
